import React, { useEffect, useState } from 'react';
import { GroupListType, GetRealTimeTrendGroupList } from '../../../function/GroupDataModel';
import { ItemComboBox, ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    labelStyle: {
      fontSize: '15px',
    },
    itemBoxStyle: {
      fontSize: '15px',
    },
  })
);

type Props = {
  onChangeEvent: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
  defalutIndex: number;
};

//グループリスト作成
const createGroupList = (data: GroupListType): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  if (data != null) {
    const gpList = data.RT_TRD_GROUP_SETs.filter((r) => r.DSP_FLG === 1);
    for (var i in gpList) {
      ret.push({
        index: gpList[i].GROUP_NO,
        name: `[${gpList[i].GROUP_NO}]` + gpList[i].GROUP_NAME,
      });
    }
  }
  return ret;
};

const RealTimeTrendGraphPageComboBox: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [groupList, setGroupList] = useState<ComboBoxItemType[]>([]);

  useEffect(() => {
    GetRealTimeTrendGroupList()
      .then((ret) => {
        setGroupList(createGroupList(ret));
      })
      .catch((reason) => {});
  }, []);

  return (
    <ItemComboBox
      value={props.defalutIndex}
      label={t('RealTimeTrendGraphPageComboBox.グループ選択', 'グループ選択：')}
      itemList={groupList}
      labelStyle={classes.labelStyle}
      itemBoxStyle={classes.itemBoxStyle}
      onChangeEvent={props.onChangeEvent}
    />
  );
};

export default RealTimeTrendGraphPageComboBox;
